import { combineReducers } from 'redux';

import codeGeneration from './codeGeneration';
import codeVerification from './codeVerification';

export default combineReducers({
  codeGeneration,
  codeVerification,
});
